class NavbarMenu {
    _openedDropDowns = []

    static init() {
        if(document.querySelector('.js-navbar')) {
            if(document.querySelector('body').classList.contains('overflow-hidden')) {
                document.querySelector('body').classList.remove('overflow-hidden');
            }
            
            return new NavbarMenu(document.querySelector('.js-navbar'));
        }
    }

    constructor(navbar) {
        this._navbar = navbar;
        this._packageInit();
    }

    _packageInit() {
        const scriptUrls = [
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/gsap.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.4/ScrollTrigger.min.js',
          ];

        window.initPackages(scriptUrls).then(() => {
            this._initListeners();
        }).catch((error) => {
            console.error(error);
        });        
    }

    _initListeners() {
        this._body =  document.querySelector('body');
        this._menuButton = document.querySelector('.js-menu-button');
        this._menuButton.addEventListener('click', this._toggleMenuContent.bind(this), false);

        if(window.innerWidth < 1200) {
            this._dropDownButtons = this._navbar.querySelectorAll('.navbar__item-button');
            this._dropDownButtons.forEach(dropDownButton => {
                dropDownButton.addEventListener('click', this._toggleDropDown.bind(this, dropDownButton), false);
            });
        }
    }

    _toggleMenuContent() {
        this._menuButton.classList.contains('open') ? this._menuButton.classList.remove('open') : this._menuButton.classList.add('open');

        if(this._navbar.dataset.opened === 'false') {
            this._navbar.dataset.opened = true;
            gsap.from(this._navbar, {duration: 0.3, autoAlpha:0, right: '-100%'});
            this._body.classList.add('overflow-hidden');
        }
        else {
            gsap.to(this._navbar, {duration: 0.3, autoAlpha:0, right: '-100%', onComplete: () => {
                this._navbar.dataset.opened = false;
                this._body.classList.remove('overflow-hidden');
                gsap.set(this._navbar, { clearProps: "all" });
            }});
        }

        if(this._openedDropDowns.length > 0) this._closeAllDropDowns();
    }

    _toggleDropDown(dropDownButton) {
        const dropDown = dropDownButton.closest('.navbar__item').querySelector('.navbar__dropdown');

        if(dropDown.dataset.dropdownOpened === 'false') {
            dropDown.dataset.dropdownOpened = true;
            this._openedDropDowns.push(dropDown);
            dropDownButton.parentElement.setAttribute('aria-expanded', true);
        }
        else {
            dropDown.dataset.dropdownOpened = false;
            dropDownButton.parentElement.setAttribute('aria-expanded', false);
            const index = this._openedDropDowns.indexOf(dropDown);

            if (index > -1) {
                this._openedDropDowns.splice(index, 1);
            }
        }
    }

    _closeAllDropDowns() {
        this._openedDropDowns.forEach(dropDown => {
            dropDown.dataset.dropdownOpened = false;
            dropDown.parentElement.querySelector('.navbar__item-wrapper').setAttribute('aria-expanded', false);
        });
    }
}

NavbarMenu.init();

document.addEventListener('LokiRequestEnd', function () {
    NavbarMenu.init();
});